import { env } from '@zopauk/nextjs-env';
import { useEffect, useState } from 'react';
import { logEvent } from '@/utils/analytics';
import { useSession } from '@zopauk/nextjs-auth';
import { Notification, Link, Text } from '@zopauk/react-components';
import AMPLITUDE_EVENTS from '@/utils/amplitudeEvents.json' with { type: 'json' };

const version = 'v2'; // Bump if copy/UI changes

export const MfaNotification = () => {
  const { data: session } = useSession();
  const [isHidden, setIsHidden] = useState<boolean>(false);

  useEffect(() => {
    if (session && session.user.mfa !== 'STRONG') {
      logEvent(AMPLITUDE_EVENTS.VIEW_MFA_NOTIFICATION, { version });
    }
  }, [session]);

  const hide = () => {
    setIsHidden(true);
    logEvent(AMPLITUDE_EVENTS.HIDE_MFA_NOTIFICATION, { version });
  };
  const setupLink = `${env('NEXT_PUBLIC_WEBSITE_URL')}/mfa?redirectUri=${encodeURIComponent(window.location.href)}`;

  const trackLinkClick = () => logEvent(AMPLITUDE_EVENTS.CLICK_MFA_NOTIFICATION, { version });

  return (session && session.user.mfa === 'STRONG') || isHidden ? null : (
    <Notification data-automation="ZA.mfa-notification" onRequestClose={hide} severity="brand" className="mb-4">
      <Text as="p">
        To make your account more secure, we now require another layer of verification when you log in.
      </Text>
      <Link onClick={trackLinkClick} href={setupLink}>
        Set up now
      </Link>
    </Notification>
  );
};
